import React, { useEffect, useMemo } from 'react'
import UserManual from '../UserManual'
import ENV from '../../modules/env'
import { selectUserSession } from '../../modules/login/sessionSlice'
import { useSelector } from 'react-redux'
import { SessionData } from '../../modules/login/Session'

const FormFramework: React.FC = () => {
  const userSession: SessionData | null = useSelector(selectUserSession)

  const rootUrl: string = useMemo(() => {
    return `${ENV.FORM_FRAMEWORK_LOGIN_HOST}?refreshToken=${userSession?.refresh_token}`
  }, [userSession])

  useEffect(() => {
    if (userSession) {
      window.location.replace(rootUrl)
    }
  }, [rootUrl])

  return <UserManual title={''} url={rootUrl as string} />
}

export default FormFramework
